<template>
  <v-menu
    v-model="menu"
    offset-y
    left
    lazy
    :close-on-content-click="false"
    :disabled="disabled"
  >
    <v-btn
      slot="activator"
      :class="[buttonTextClass]"
      :disabled="disabled"
      :flat="!!buttonLabel"
      :icon="!buttonLabel"
      :round="!!buttonLabel"
      :title="$t(tooltip)"
      class="ma-0"
      data-cy="tag-select-activator"
    >
      <v-badge
        color="transparent"
        class="nudged-left"
      >
        <template
          v-if="!tagEntriesCanBeDeactivated"
          slot="badge"
        >
          <v-icon
            class="warning--text"
            :title="$t('contentManagementEnableTagEntriesCanBeDeactivated')"
            style="cursor: help"
          >
            lock
          </v-icon>
        </template>
        <v-icon
          v-if="buttonIcon"
          class="hoverable-icon"
          :class="[buttonIconClass]"
          :left="!!buttonLabel && !!tagEntriesCanBeDeactivated"
          :medium="medium"
        >
          {{ buttonIcon }}
        </v-icon>
      </v-badge>
      <div :class="{'ml-3': !!buttonIcon && !tagEntriesCanBeDeactivated}">
        {{ buttonLabel }}
      </div>
    </v-btn>
    <v-list
      dense
      style="max-height: 90vh; overflow: auto"
    >
      <!-- Manage Tags -->
      <v-list-tile
        v-if="showManageTagsLink"
        :title="$t('tagsManagement')"
        @click="$router.push({name: 'tagsmanage'})"
      >
        <v-icon class="mr-1 grey--text">
          shortcut
        </v-icon>
        {{ $t('tagsManagement') }}
      </v-list-tile>
      <slot name="extra-tile" />
      <!-- Search (when many) -->
      <v-list-tile
        v-if="showSearchWidget"
        :title="$t('search')"
        class="list-tile-auto-height"
      >
        <v-text-field
          ref="tagSelectSearchInput"
          v-model="searchText"
          type="search"
          prepend-icon="search"
          :placeholder="$t('filterTags') + '...'"
          hide-details
          class="pt-0 mb-2"
          clearable
          @keyup.esc="searchText = ''"
        />
      </v-list-tile>
      <v-divider
        v-if="
          filteredTags.length > 0 && (showManageTagsLink || showExtraDivider)
        "
      />
      <v-list-tile
        v-for="tag in filteredTags"
        :key="tag.id"
        :title="$t(addTooltip)"
        @click="onTagChosen(tag)"
      >
        <v-chip
          small
          :color="getTagColor(tag)"
          class="clickable"
          data-cy="tag-select-tag-chip"
        >
          <span :style="{color: getTagTextColor(tag)}">{{ tag.name }}</span>
        </v-chip>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import matchesFilter from '@/matchesFilter';

import tagsMixin from '@/mixins/tags';

export default {
  mixins: [tagsMixin],
  props: {
    tags: {
      type: Array[Object],
      required: true,
    },
    tooltip: {
      type: String,
      default: 'tags',
    },
    addTooltip: {
      type: String,
      default: 'addTagToSpot',
    },
    medium: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonTextClass: {
      type: String,
      default: 'grey--text text--darken-1',
    },
    buttonIcon: {
      type: [String, Boolean],
      default: 'tag',
    },
    buttonIconClass: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    showManageTagsLink: {
      type: Boolean,
      default: true,
    },
    tagEntriesCanBeDeactivated: {
      type: Boolean,
      default: true,
    },
    showExtraDivider: {
      type: Boolean,
      default: false,
    },
    resetSearchOnClose: {
      type: Boolean,
      default: true,
    },
    /**
     * Whether to focus the search input as dropdown is shown.
     *
     * Does not trigger for mobile, where this is not convenient.
     */
    autoFocusSearchOnOpen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menu: false,
      searchText: '',
    };
  },
  computed: {
    showSearchWidget() {
      return this.tags && this.tags.length >= 10;
    },
    filteredTags() {
      if (!this.searchText) {
        return this.tags;
      }
      return this.tags.filter((tag) => {
        return matchesFilter(tag.name, this.searchText);
      });
    },
  },
  watch: {
    menu: function (show) {
      if (!show && this.resetSearchOnClose) {
        this.resetSearchText();
      }
      if (
        show &&
        this.showSearchWidget &&
        this.autoFocusSearchOnOpen &&
        this.$vuetify.breakpoint.mdAndUp
      ) {
        setTimeout(() => {
          this.$refs.tagSelectSearchInput.focus();
        }, 150);
      }
    },
  },
  methods: {
    close() {
      this.menu = false;
    },
    resetSearchText() {
      this.searchText = '';
    },
    onTagChosen(tag) {
      this.$emit('add', tag);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TagSelect.vue